import {FC, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  fetchActiveIntegrationApp,
  fetchExternalProviders,
  getActivateIntegrationIds,
  getExternalProviders,
} from './IntegrationSlice/IntegrationSlice'
import {ExternalProvider} from './IntegrationSlice/Types'
import {useNavigate} from 'react-router-dom'
import { getDefaultRegion } from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { REGION } from '../../../Utils/Constant/ConstantForWebsite'

const IntegrationPage: FC = () => {
  let externalProviders = useSelector(getExternalProviders)
  let activeIds = useSelector(getActivateIntegrationIds)
  const userRegion = useSelector(getDefaultRegion)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // load data when first load
  useEffect(() => {
    dispatch(fetchExternalProviders())
    dispatch(fetchActiveIntegrationApp())
  }, [])

  const onButtonItemClick = (id: string) => {
    // console.debug(`[integrationPage] selected provider id : ${id}`)
    navigate(`/integration/${id}`)
  }

  const getIntegrationProvider = () => {
    let integrationProviders = externalProviders;

    const regionIntegration = externalProviders.filter(pvd => pvd.code === 'ghl');
    if ([REGION.UK, REGION.US].includes(userRegion)) {
      integrationProviders = regionIntegration;
    }

    return integrationProviders;
  }
  
  return (
    <>
      <div className='card p-5 mx-2'>
        <h1>Integration Page</h1>
      </div>
      {externalProviders?.length > 0 ? (
        <>
          <div className='d-flex flex-row flex-wrap card-number-div-wrapper mr-0'>
            {getIntegrationProvider().map((ep: ExternalProvider) => (
              <div className='card w-400px mt-5 text-center'>
                <div className='card-body'>
                  <h3 className='card-title'> {ep.name}</h3>
                  <img
                    src={ep?.image}
                    alt='poster'
                    className='rounded-3 mb-2'
                    style={{width: '200px', height: '200px'}}
                  />
                  <button
                    className={`btn w-100 px-4 btn-sm btn-icon m-1 text-nowrap ${
                      activeIds.includes(ep._id) ? 'btn-bg-light' : 'btn-primary'
                    }`}
                    onClick={() => onButtonItemClick(ep._id)}
                  >
                    {activeIds.includes(ep._id) ? 'Detail' : 'Activate'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className='card border mt-10'>
          <div className='card-body'>
            <p className='card-text text-center text-bold'>No available app to integrate</p>
          </div>
        </div>
      )}
    </>
  )
}

const IntegrationWrapper: FC = () => {
  return (
    <>
      <IntegrationPage />
    </>
  )
}

export {IntegrationWrapper}
